import { render, staticRenderFns } from "./latest.vue?vue&type=template&id=19721fa2&scoped=true&"
import script from "./latest.vue?vue&type=script&lang=js&"
export * from "./latest.vue?vue&type=script&lang=js&"
import style0 from "./latest.vue?vue&type=style&index=0&id=19721fa2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19721fa2",
  null
  
)

export default component.exports